const MATERIAL_UI_MODAL_SELECTOR = ".MuiModal-root, .MuiDialog-root";

export const clearStaleBodyScrollLock = () => {
  if (typeof document === "undefined") {
    return;
  }

  if (document.querySelector(MATERIAL_UI_MODAL_SELECTOR)) {
    return;
  }

  if (document.body.style.overflow === "hidden") {
    document.body.style.removeProperty("overflow");
  }

  if (document.body.style.paddingRight) {
    document.body.style.removeProperty("padding-right");
  }
};
